export default __webpack_public_path__ + "static/media/pag11.dc79dbd9.jpg";